// CDN animal avatar URL helpers for Feed The Farm.

import React from 'react';
import {
  ASSETS,
  getAnimalAssetPrefixForPlayerColorKey,
} from '@airhead-games/shared/configs';
import type { Emotion } from '@airhead-games/shared/configs';
import {
  getColorStop,
  type PlayerColorFamily,
} from '../../../styles/playerColors';

export function emotionToAnimalMood(emotion: Emotion): 'happy' | 'sad' {
  switch (emotion) {
    case 'sad':
    case 'angry':
    case 'dead':
      return 'sad';
    default:
      return 'happy';
  }
}

/**
 * Full CDN URL for the animal SVG. Uses `ASSETS.avatarAnimalsBase` unless `baseUrl` is set.
 */
export function getAnimalAssetUrl(
  playerColorKey: string,
  emotion: Emotion,
  baseUrl: string = ASSETS.avatarAnimalsBase
): string | null {
  const prefix = getAnimalAssetPrefixForPlayerColorKey(playerColorKey);
  if (!prefix) return null;
  const mood = emotionToAnimalMood(emotion);
  const suffix = mood === 'happy' ? 'Happy' : 'Sad';
  return `${baseUrl}/${prefix}${suffix}.svg`;
}

export function renderAnimalHappySwatch(colorKey: string): React.ReactNode {
  const src = getAnimalAssetUrl(colorKey, 'happy');
  const hex = getColorStop(colorKey as PlayerColorFamily, '300');

  if (!src) {
    return React.createElement('span', {
      className: 'block size-full rounded-full',
      style: { backgroundColor: hex },
    });
  }

  return React.createElement('img', {
    src,
    alt: '',
    className:
      'pointer-events-none absolute inset-0 size-full origin-[center_42%] scale-[2.25] object-cover object-[center_38%] select-none',
    draggable: false,
  });
}

export { getAnimalAssetPrefixForPlayerColorKey };
